import type {
    CatalogItem,
    GlobalCatalogItem,
} from '../model/types/CatalogItemSchema';
import type { CatalogIdentity } from 'shared/lib/contexts/CatalogIdentityContext';

/**
 * Stable id for catalog UI: keys `selectedItems`, ties a row to list data, and drives checkbox `selectionKey`.
 *
 * - **Add-items + property row:** `uuid ?? id` (prefer frozen product uuid when present).
 * - **Legacy property catalog:** `id` (catalog row id).
 * - **Global marketplace row:** `uid`.
 *
 * HTTP bodies for add-to-order use `catalogItemId` / marketplace uuid via builders — not this value alone.
 */
export const getItemUid = (
    item: CatalogItem | GlobalCatalogItem,
    identity: CatalogIdentity,
): string => {
    if ('id' in item) {
        return identity.flow === 'orders-add-items' ||
            identity.flow === 'lists-add-items'
            ? item.uuid ?? item.id
            : item.id;
    }
    return item.uid;
};
